import { config } from "./configs";
export const APIURL = config.APIURL;
export const TENANT_KEY = config.TENANT_KEY;
export const MEDIAPATH = config.MEDIAPATH;
export const IMGPATH = config.IMGPATH;
export const currentEventCode = "Common-Job-Application";
export const BASEPATH = "/portfolio"